import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	UpdateRefundProcedure,
	UpdateRefundProcedureParams,
	UpdateRefundProcedureResponse,
} from 'domain/usecases/private/refund/request/update-procedure';

export class RemoteRefundUpdateProcedure implements UpdateRefundProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<UpdateRefundProcedureResponse>,
	) {}

	async update(params: UpdateRefundProcedureParams): Promise<UpdateRefundProcedureResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'put',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
